import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { categoryIcons } from "../Constants/categoryIcons";
import { useMatomo } from "@datapunt/matomo-tracker-react";
  
const MostPopularCategories = ({ categories, t, getTheListings }) => {

  const [selectedCategory, setSelectedCategory] = useState(null);
  const location = useLocation();
  const { trackEvent } = useMatomo();
  const matomoStatus = process.env.REACT_APP_MATOMO_STATUS === "True";

  // On mount or URL change, read ?categoryId=
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categoryIdParam = searchParams.get("categoryId");
    if (categoryIdParam) {
      // convert param to integer
      setSelectedCategory(parseInt(categoryIdParam, 10));
    } else {
      // means "All Categories"
      setSelectedCategory(null);
    }
  }, [location.search]);

  // We handle clicks. If the user re-clicks the same category, we can toggle back to "all categories" (null).
  const handleCategoryClick = (clickedCategoryId, categoryName, e) => {
    e.preventDefault();

    // If we are already on the same category, toggle to "All Categories"
    if (selectedCategory === clickedCategoryId) {
      setSelectedCategory(null);
      getTheListings(null, e); // tell parent to load all categories
    } else {
      setSelectedCategory(clickedCategoryId);
      getTheListings(clickedCategoryId, e);
    }

    if (matomoStatus) {
      trackEvent({
        category: "Category",
        action: "Click",
        name: categoryName,
        value: clickedCategoryId,
      });
    }
  };

  return (
    <div className="px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] flex flex-col w-full">
      <div className="flex flex-row relative items-center justify-center">
        <div className="flex justify-between w-full category-animation rounded-t-xl">
          <div className="flex overflow-x-scroll">
            <div className="flex flex-nowrap md:gap-20 gap-8">
              {/* "All Categories" tab */}
              <h2
                className={`flex font-bold gap-4 p-2 md:p-4 hover:text-gray-700 ${selectedCategory === null
                  ? "bg-white text-gray-900"
                  : "text-white"
                  } rounded-t-xl inline-flex text-lg md:text-xl lg:text-2xl items-center justify-center whitespace-nowrap cursor-pointer`}
                style={{
                  fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                  transition: "background-color 0.3s, color 0.3s",
                }}
                onClick={(e) => handleCategoryClick(null, "allCategories", e)}
              >
                {t("allCategories")}
              </h2>

              {/* Real category tabs */}
              {Array.isArray(categories) &&
                categories.map((category) => {
                  const categoryId = category.id;
                  const categoryName = category.name;
                  const categoryIcon = categoryIcons[categoryId]?.svgIcon;

                  const isSelected = selectedCategory === categoryId;

                  return (
                    <h2
                      key={categoryId}
                      className={`flex font-bold gap-2 p-2 md:p-4 hover:text-gray-500 ${isSelected ? "bg-white text-gray-800" : "text-white"
                        } rounded-t-xl inline-flex text-lg md:text-xl lg:text-2xl items-center justify-center whitespace-nowrap cursor-pointer`}
                      style={{
                        fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                        transition: "background-color 0.3s, color 0.3s",
                      }}
                      onClick={(e) =>
                        handleCategoryClick(categoryId, categoryName, e)
                      }
                    >
                      {categoryIcon && (
                        <svg
                          className="h-4 w-8 fill-current"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox={categoryIcons[categoryId]?.viewBox || "0 0 512 512"}
                        >
                          <path d={categoryIcon} />
                        </svg>
                      )}
                      {t(categoryName)}
                    </h2>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MostPopularCategories.propTypes = {
  categories: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  getTheListings: PropTypes.func.isRequired,
};


export default MostPopularCategories;